module.exports = __webpack_public_path__ + "static/media/AVeryBigFallBookCover.1b17317c.jpg";